import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { EvaluationRiskService } from '../../service/evaluation-risk.service';
import { ProcessParameter } from '../../../../graphql/generated';
import { RiskmapService } from '../../service/riskmap.service';
import { EvaluationActions, RiskEvaluationActions } from './evaluation.actions';


@Injectable()
export class EvaluationEffects {

  loadEvaluation$ = createEffect(
    (rs: RiskmapService = inject(RiskmapService)) => {
      return this.actions$.pipe(

        ofType(EvaluationActions.loadEvaluations),
        mergeMap((parameters) =>
          rs.getRiskmapByEntityAndYear(parameters.legalEntityId, parameters.campaignId, parameters.parameters).pipe(
            map((riskMap) => {
              return EvaluationActions.loadEvaluationsSuccess({
                riskMap: riskMap,
                filtering: parameters.filtering
              });
            }),
            catchError((error) => of(EvaluationActions.loadEvaluationsFailure({ error })))
          )
        )
      );
    },
    { functional: true }
  );

  loadProcessOverallEvaluation$ = createEffect(
    (rs: RiskmapService = inject(RiskmapService)) => {
      return this.actions$.pipe(

        ofType(EvaluationActions.loadEvaluationsOverall),
        mergeMap((parameters) =>
          /** An EMPTY observable only emits completion. Replace with your own observable API request */
          rs.getProcessOverall(parameters.legalEntityId, parameters.campaignId, parameters.parameters).pipe(
            map((riskMap) => {
              return EvaluationActions.loadEvaluationsOverallSuccess({
                riskMap: riskMap,
                filtering: parameters.filtering
              });
            }),
            catchError((error) => of(EvaluationActions.loadEvaluationsOverallFailure({ error })))
          )
        )
      );
    },
    { functional: true }
  );
  loadRiskOverallEvaluation$ = createEffect(
    (rs: RiskmapService = inject(RiskmapService)) => {
      return this.actions$.pipe(

        ofType(EvaluationActions.loadEvaluationsRiskOverall),
        mergeMap((parameters) =>
          /** An EMPTY observable only emits completion. Replace with your own observable API request */
          rs.getRiskOverall(parameters.legalEntityId, parameters.campaignId, parameters.parameters).pipe(
            map((riskMap) => {
              return EvaluationActions.loadEvaluationsRiskOverallSuccess({
                riskMap: riskMap,
                filtering: parameters.filtering
              });
            }),
            catchError((error) => of(EvaluationActions.loadEvaluationsRiskOverallFailure({ error })))
          )
        )
      );
    },
    { functional: true }
  );

  loadEvaluationNames$ = createEffect(
    (as: EvaluationRiskService = inject(EvaluationRiskService)) => {
      return this.actions$.pipe(
        ofType(EvaluationActions.loadEvaluationNames),
        mergeMap(() =>
          as.getEvaluationName().pipe(
            map((evaluation) =>
              EvaluationActions.loadEvaluationNamesSuccess({
                evaluation: evaluation as ProcessParameter[]
              })
            ),
            catchError((error) =>
              of(EvaluationActions.loadEvaluationNamesFailure({ error }))
            )
          )
        )
      );
    },
    { functional: true }
  );

  loadEvaluationRisk$ = createEffect(
    (rs: EvaluationRiskService = inject(EvaluationRiskService)) => {
      return this.actions$.pipe(

        ofType(RiskEvaluationActions.loadEvaluations),
        mergeMap((parameters) =>
          /** An EMPTY observable only emits completion. Replace with your own observable API request */
          rs.loadEvaluationRisk(parameters.campaignId, parameters.riskId, parameters.parameters).pipe(
            map((riskMap) => {
              return RiskEvaluationActions.loadEvaluationsSuccess({
                riskMap: riskMap,
                filtering: parameters.filtering
              });
            }),
            catchError((error) => of(RiskEvaluationActions.loadEvaluationsFailure({ error })))
          )
        )
      );
    },
    { functional: true }
  );


  updateRiskEvaluation$ = createEffect(
    (rs: RiskmapService = inject(RiskmapService)) => {
      return this.actions$.pipe(

        ofType(RiskEvaluationActions.updateEvaluation),
        mergeMap((props) =>
          /** An EMPTY observable only emits completion. Replace with your own observable API request */
          rs.updateRiskEvaluation(
            props.riskMapId,
            props.impactId,
            props.controlSystemId as string,
            props.likelihoodId as string
          ).pipe(
            map((riskMap) => {
              return RiskEvaluationActions.updateEvaluationSuccess({
                riskMap: riskMap,
                parameterName: props?.parameterName as string,
                cptIds: props?.cptIds as [],
                parameterCell: props?.parameterCell as string
              });
            }),
            catchError((error) => of(RiskEvaluationActions.updateEvaluationFailure({ error })))
          )
        )
      );
    },
    { functional: true }
  );

  constructor(private actions$: Actions) { }
}
